import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import InputText from "../components/Form/InputText";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import Textarea from "../components/Form/Textarea";

export default function ContactDetails() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                initialValues={{
                    ...formData,
                    phonenumbercontact: formData.phonenumberapp || formData.phonenumbercontact,  // use previous phonenumber if available, or an empty string
                    emailcontact: formData.valuecodeemail || formData.emailcontact,  // use previous email if available, or an empty string
                }}
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/granska-och-skicka");

                }}

                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    firstname: Yup.string().required(
                        "Vänligen fyll i ditt förnamn"
                    ),
                    lastname: Yup.string().required(
                        "Vänligen fyll i ditt efternamn"
                    ),
                    streetaddress: Yup.string().required(
                        "Vänligen fyll i din gatuadress"
                    ),
                    zipcode: Yup.string().required(
                        "Vänligen fyll i ditt postnummer"
                    ),
                    postaladdress: Yup.string().required(
                        "Vänligen fyll i din postort"
                    ),
                    phonenumbercontact: Yup.string().required(
                        "Vänligen fyll i ditt telefonnummer"
                    ),
                    emailcontact: Yup.string()
                        .required("Vänligen fyll i din mejladress")
                        .email("Vänligen ange en korrekt mejladress"),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"90"} />
                            </div>
                        </div>
                        <Form noValidate>

                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="">
                                    Personuppgifter
                                </h2>

                                <p>
                                    Till sist är det bara dina personuppgifter som vi behöver veta.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="firstname"
                                    label={
                                        <>
                                            Förnamn <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                    autocomplete={"firstname"}
                                />

                                <InputText
                                    name="lastname"
                                    label={
                                        <>
                                            Efternamn <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                    autocomplete={"surname"}
                                />

                                <InputText
                                    name="streetaddress"
                                    label={
                                        <>
                                            Gatuadress <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                // autocomplete={"surname"}
                                />

                                <InputText
                                    name="zipcode"
                                    label={
                                        <>
                                            Postnummer <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="number"
                                    
                                // autocomplete={"surname"}
                                />

                                <InputText
                                    name="postaladdress"
                                    label={
                                        <>
                                            Postort <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                // autocomplete={"surname"}
                                />

                                <InputText
                                    name="phonenumbercontact"
                                    label={
                                        <>
                                            Telefonnummer för kontakt <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="tel"
                                    autocomplete={"off"}
                                    numbersOnly
                                />

                                <InputText
                                    name="emailcontact"
                                    label={
                                        <>
                                            Mejladress för kontakt <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="email"
                                    autocomplete={"email"}
                                />

                                <h3>
                                    Övrig information
                                </h3>
                                <p>
                                    Ange eventuell information om din resa som du vill att vi ska veta och ta till oss.
                                </p>

                                <Textarea
                                    name="moreinfo"
                                    maxLength={5000}
                                    currentText={values.moreinfo}
                                    label={
                                        <>
                                            Information om resan <span>(Frivilligt)</span>
                                        </>
                                    } />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
